import React, { useState, useEffect } from "react";

import VerifiedIcon from "@mui/icons-material/Verified";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { IoMenu } from "react-icons/io5";

import VuiProgress from "components/VuiProgress";
import VuiOpenLink from "components/VuiOpenLink";
import VuiBox from "components/VuiBox";
import VuiLoading from "components/VuiLoading";
import VuiLabel from "components/VuiLabel";
import VuiInfoItemPrinter from "components/VuiInfoItemPrinter";

import api from "services/api";
import colors from "assets/theme/base/colors";

import moment from "moment";

// Function randomInt(min, max)
// min and max included
function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

const padLeft = (num, places) => String(num).padStart(places, "0");

function PrinterStatics() {
  const [refreshInterval, setRefreshInterval] = useState(60000);
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [countOffLines, setCountOfflines] = useState(0);
  const [countOnLines, setCountOnlines] = useState(0);
  const [countAllUnits, setCountAllUnits] = useState(0);

  async function loadPrinters() {
    setLoading(true);
    const res = await api.get("printers");

    const data = [];
    res.data.map((x) => {
      if (x.enabled === 1) {
        data.push({
          initials: x.initials,
          name: x.name,
          factoryPrinter: x.factoryPrinter,
          modelPrinter: x.modelPrinter,
          serialPrinter: x.serialPrinter,
          isColorPrinter: x.isColorPrinter,
          countPageFranchise: x.countPageFranchise,
          currentBilling: x.currentBilling,
          countPageOverPlus: x.currentBilling - x.countPageFranchise,
          percentageBilling: ((x.currentBilling / x.countPageFranchise) * 100).toFixed(2),
          location: x.location,
          ip: x.ip,
          status: x.status === 1,
          countPage: x.countPage || 0,
          maxLevelToner: x.maxLevelToner || 0,
          currentLevelToner: x.currentLevelToner || 0,
          calcValue: ((x.currentLevelToner / x.maxLevelToner) * 100).toFixed(0),
          order: padLeft(((x.currentLevelToner / x.maxLevelToner) * 100).toFixed(0), 3),
          updatedAt: moment(x.updatedAt).format("DD/MM/YYYY HH:mm:ss"),
        });
      }
    });
    const roundPrinter = randomInt(0, data.length - 1);

    setCountOfflines(data.filter((x) => !x.status).length);
    setCountOnlines(data.filter((x) => x.status).length + 1);
    setCountAllUnits(data.length + 1);
    setRows(data[roundPrinter]);
    setInterval(() => {
      setLoading(false);
    }, 1000);
  }

  useEffect(() => {
    loadPrinters();
  }, [false]);

  useEffect(() => {
    if (refreshInterval && refreshInterval > 0) {
      const interval = setInterval(loadPrinters, refreshInterval);
      return () => clearInterval(interval);
    }
  }, [refreshInterval]);

  return (
    <>
      {loading ? (
        <VuiLoading height={110} />
      ) : (
        <>
          <VuiBox display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
            <IoMenu size={32} style={{ marginRight: 10 }} />
            <VuiLabel
              title={`Impressoras`}
              colorTitle="warning"
              fontWeight="bold"
              sizeTitle={24}
              openLinkClick={"printers"}
            />
          </VuiBox>

          <div
            style={{
              display: "grid",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginBottom: 20,
            }}
          >
            <VuiBox display="flex" flexDirection="row" justifyContent="flex-end">
              {countOffLines > 0 ? (
                <>
                  <div style={{ textAlign: "right", color: colors.warning.main }}>
                    {countOffLines > 0 && countOffLines < countAllUnits
                      ? ((countOffLines / countAllUnits) * 100).toFixed(2)
                      : 100}
                    %
                  </div>
                  <div
                    style={{
                      fontWeight: "bold",
                      textAlign: "right",
                      color: colors.error.main,
                    }}
                  >
                    Offline
                  </div>
                </>
              ) : (
                <>
                  <div style={{ textAlign: "right", color: colors.success.focus }}>100%</div>
                  <div
                    style={{ fontWeight: "bold", textAlign: "right", color: colors.success.main }}
                  >
                    Online
                  </div>
                </>
              )}
            </VuiBox>
            <VuiProgress
              value={(countOffLines / countAllUnits) * 100}
              color="error"
              label={false}
            />
          </div>
          <VuiBox display={"flex"} flexDirection={"column"} justifyContent={"flex-end"}>
            <VuiBox
              display={"flex"}
              flexDirection={"rows"}
              justifyContent={"flex-end"}
              alignItems={"center"}
            >
              <VerifiedIcon fontSize="medium" color="success" />
              <VuiOpenLink
                title={`Visualizar ${countOnLines} ${countOnLines > 1 ? "impressoras" : "impressora"} Online`}
                colorTitle={"success"}
                url="printers?search=online"
              />
            </VuiBox>

            <VuiBox
              display={"flex"}
              flexDirection={"rows"}
              justifyContent={"flex-end"}
              alignItems={"center"}
            >
              {countOffLines > 0 ? (
                <>
                  <NotificationsActiveIcon fontSize="medium" color="error" />
                  <VuiOpenLink
                    title={`${countOffLines} ${
                      countOffLines > 1 ? "impressoras" : "impressora"
                    } Offine de ${countAllUnits} Ativas`}
                    colorTitle={"error"}
                    url="printers?search=offline"
                  />
                </>
              ) : (
                <VuiLabel title={``} colorTitle="error" fontWeight="bold" sizeTitle={18} />
              )}
            </VuiBox>
          </VuiBox>
        </>
      )}
    </>
  );
}

export default PrinterStatics;
